import { render } from "./PreviousEntries.vue?vue&type=template&id=3273c9a0&scoped=true"
import script from "./PreviousEntries.vue?vue&type=script&lang=js"
export * from "./PreviousEntries.vue?vue&type=script&lang=js"

import "./PreviousEntries.vue?vue&type=style&index=0&id=3273c9a0&scoped=true&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/dynamik_webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3273c9a0"]])

export default __exports__